import useSWR, { SWRResponse } from 'swr';
import hash from 'object-hash';
import { getLatestSold, PropertyFilters } from '../../../services/properties/properties';
import { PropertySearchResult } from '../../../services/dtos/property';
import { PaginationParams } from '../../../domain/pagination';

export default function useLatestSoldProperties(
  filters: Pick<PropertyFilters, 'province'> | null,
  pagination: Pick<PaginationParams, 'size'> = { size: 5 },
): SWRResponse<PropertySearchResult[], Error> {
  return useSWR(
    filters ? ['useLatestSoldProperties', hash(filters), hash(pagination)] : null,
    () => getLatestSold(filters, pagination),
  );
}
